import type { LandingData } from "../data/types"
import { CTA } from "../components/CTA"

export function Section8Footer({ data }: { data: LandingData }) {
  return (
    <div className="copy-block final-copy" data-motion="reveal">
      <CTA display />
      <p className="footer-line mono">V&apos; VERUS · BUILD {data.build.snapshot_date} · {data.build.git_sha || "local"} · guilherme.dietz.brune@gmail.com</p>
    </div>
  )
}
